<form #form="ngForm" novalidate class="cliente-analise-mercado-projecao-form" [class.embedded]="embedded">
    <div class="card card-primary">
        <div class="card-header" *ngIf="!embedded">
            <div class="card-header-title">
                <h6 class="card-title mb-0">Projeções do Cliente na Análise de Mercado</h6>
                <small class="card-subtitle mb-0" *ngIf="cardSubtitle">{{cardSubtitle}}</small>
            </div>
        </div>

        <ng-template [ngIf]="!isLoading">
            <div class="card-body pb-0">
                <div class="row">
                    <div class="form-group col-12">
                        <label class="col-form-label">Cliente</label>

                        <ng-template [ngIf]="canEditCliente && entity">
                            <sgt-typeahead-cliente [(ngModel)]="entity.cliente" name="projecaoFormCliente" id="projecaoFormCliente"
                                #typeaeadCliente #projecaoFormCliente="ngModel" [ngControl]="projecaoFormCliente" required="required"
                                (entitySelected)="onSelectCliente($event)" (clearEntity)="onClearCliente()">
                            </sgt-typeahead-cliente>
                            <sgt-form-control-error
                                *ngIf="projecaoFormCliente.errors && projecaoFormCliente.errors.required && projecaoFormCliente.dirty"
                                msgError="O cliente é obrigatório">
                            </sgt-form-control-error>   
                        </ng-template>

                        <ng-template [ngIf]="!canEditCliente">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">{{entity?.codigoIntegracaoErpCliente}}</span>
                                </div> 
                                <input type="text" class="form-control" [value]="entity?.nomeCliente" disabled="disabled" readonly="readonly">                           
                            </div>
                            <p class="form-text text-muted">
                                {{entity?.nomeFantasiaCliente}} - {{entity?.cnpjCpfCliente}} - {{entity?.nomeCidadeCliente}} - {{entity?.ufCliente}}
                            </p>
                        </ng-template>                        
                    </div>
                </div>
                <div class="row" *ngIf="!isRepresentante">
                    <div class="form-group col-12">
                        <label class="col-form-label">Representante</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{entity?.codigoIntegracaoErpRepresentante}}</span>
                            </div> 
                            <input type="text" class="form-control" [value]="entity?.nomeRepresentante ? entity?.nomeRepresentante : ''" disabled="disabled" readonly="readonly">                           
                        </div>
                        <p class="form-text text-muted">
                            {{entity?.nomeFantasiaRepresentante}}
                        </p>                        
                    </div>
                </div> 
                <div class="row">
                    <div class="form-group col-12 col-sm-3 col-md-2">
                        <label class="col-form-label">Mês</label>
                        <input type="text" class="form-control" value="{{mes}}/{{ano}}" disabled="disabled" readonly="readonly">                       
                    </div>
                </div>                                
            </div>
            <ng-template [ngIf]="entity?.classificacoes?.length > 0">
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered table-cliente-analise-mercado-classificacao">
                        <thead>
                            <tr>
                                <th class="col-nome col-sticky row-span-2" rowspan="2" colspan="2"></th>
                                <th class="col-status text-center row-span-2" rowspan="2">Status<br/>Projetado</th>                               
                                <th class="col-quantidade text-center" colspan="4" *ngIf="configEmpresa?.controleQuantidade">Quantidade</th>
                                <th class="col-peso text-center" colspan="4" *ngIf="configEmpresa?.controlePeso">Peso</th>
                                <th class="col-valor text-center" colspan="3" *ngIf="configEmpresa?.controleValor">Valor</th>
                            </tr>
                            <tr>                               
                                <!-- Quantidade -->
                                <ng-template [ngIf]="configEmpresa?.controleQuantidade">
                                    <th class="col-quantidade col-valor-unitario text-right">Preço Médio</th>
                                    <th class="col-quantidade col-quantidade-pretendida text-right">Pretendida</th>
                                    <th class="col-quantidade col-quantidade-projetada text-right">Projetada</th>
                                    <th class="col-quantidade col-quantidade-un-realizada text-right">Realizada</th>
                                </ng-template>

                                <!-- Peso -->
                                <ng-template [ngIf]="configEmpresa?.controlePeso">
                                    <th class="col-peso col-valor-unitario text-right">Preço Médio</th>
                                    <th class="col-peso col-peso-pretendido text-right">Pretendido</th>
                                    <th class="col-peso col-peso-projetado text-right">Projetado</th>
                                    <th class="col-peso col-peso-realizado text-right">Realizado</th>
                                </ng-template>                                

                                <!-- Valor -->                                
                                <ng-template [ngIf]="configEmpresa?.controleValor">
                                    <th class="col-valor col-valor-pretendido text-right">Pretendido</th>
                                    <th class="col-valor col-valor-projetado text-right">Projetado</th>
                                    <th class="col-valor col-valor-realizado text-right">Realizado</th>
                                </ng-template>
                            </tr>
                        </thead>

                        <!-- Classificações -->
                        <tbody *ngFor="let entityClassificacao of entity?.classificacoes; let entityClassificacaoIndex = index; let last = last">
                            <tr [class.lancamento-quantidade]="isLancamentoQuantidade(entityClassificacao)"
                                [class.lancamento-peso]="isLancamentoPeso(entityClassificacao)"
                                [class.lancamento-valor]="isLancamentoValor(entityClassificacao)">
                                <td class="col-options col-sticky text-center">
                                    <button type="button" class="btn btn-link btn-link-delete p-0" title="Remover projeção do segmento" tabindex="-1"
                                        (click)="removeProjecaoMensal(entityClassificacaoIndex, entityClassificacao)">
                                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                                    </button>
                                </td>                                            
                                <td class="col-nome col-sticky">
                                    {{entityClassificacao.classificacoesNome}}
                                </td>

                                <td class="col-status col-status-projetado text-center">
                                    <sgt-cliente-analise-mercado-status-projetado-badge-pill
                                        [statusProjetado]="entityClassificacao.statusProjetado">
                                    </sgt-cliente-analise-mercado-status-projetado-badge-pill>
                                </td>

                                <!-- Quantidade -->
                                <ng-template [ngIf]="configEmpresa?.controleQuantidade">
                                    <td class="col-quantidade col-valor-unitario text-right">
                                        <ng-template [ngIf]="canEditLancamentoQuantidade(entityClassificacao) && entityClassificacao.solicitarPrecoMedio">
                                            <sgt-decimal2 [ngModel]="entityClassificacao.quantidadeProjetadaValorUnitario" name="quantudadeProjetadaValorUnitario_{{entityClassificacaoIndex}}" id="quantudadeProjetadaValorUnitario_{{entityClassificacaoIndex}}"
                                                #quantudadeProjetadaValorUnitario="ngModel" [ngControl]="quantudadeProjetadaValorUnitario" #quantidadeProjetadaValorUnitarioDecimal
                                                (ngModelChange)="onChangeQuantidadeProjetadaValorUnitario(entityClassificacao, $event)" [required]="isQuantidadeProjetadaValorUnitarioRequired(entityClassificacao)">
                                            </sgt-decimal2>
                                        </ng-template>
                                    </td>
                                    <td class="col-quantidade col-quantidade-pretendida text-right">
                                        {{entityClassificacao.quantidadePretendida | decimalFormat: 1:0:0}}                                      
                                    </td>
                                    <td class="col-quantidade col-quantidade-projetada text-right">
                                        <ng-template [ngIf]="canEditLancamentoQuantidade(entityClassificacao)">
                                            <sgt-decimal2 [ngModel]="entityClassificacao.quantidadeProjetada" name="quantidadeProjetada_{{entityClassificacaoIndex}}" id="quantidadeProjetada_{{entityClassificacaoIndex}}"
                                                #quantidadeProjetada="ngModel" [ngControl]="quantidadeProjetada" [digits]="0"
                                                (ngModelChange)="onChangeQuantidadeProjetada(entityClassificacao, $event)">
                                            </sgt-decimal2>
                                        </ng-template> 
                                        
                                        <ng-template [ngIf]="!canEditLancamentoQuantidade(entityClassificacao)">
                                            {{entityClassificacao.quantidadeProjetada | decimalFormat: 1:0:0}}                    
                                        </ng-template>

                                        <div class="progress-container" *ngIf="canEditLancamentoQuantidade(entityClassificacao)">
                                            <div class="progress-value">
                                                {{entityClassificacao.quantidadeProjetadaPerc | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entityClassificacao.quantidadeProjetadaPerc + '%'"
                                                    [attr.aria-valuenow]="entityClassificacao.quantidadeProjetadaPerc" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>                                          
                                    </td>
                                    <td class="col-quantidade col-quantidade-un-realizada text-right">
                                        {{entityClassificacao.quantidadeRealizada | decimalFormat: 1:0:0}}

                                        <div class="progress-container" *ngIf="canEditLancamentoQuantidade(entityClassificacao)">
                                            <div class="progress-value">
                                                {{entityClassificacao.quantidadeRealizadaPercProjetada | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entityClassificacao.quantidadeRealizadaPercProjetada + '%'"
                                                    [attr.aria-valuenow]="entityClassificacao.quantidadeRealizadaPercProjetada" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>                                         
                                    </td>
                                </ng-template>

                                <!-- Peso -->
                                <ng-template [ngIf]="configEmpresa?.controlePeso">
                                    <td class="col-peso col-valor-unitario text-right">
                                        <ng-template [ngIf]="canEditLancamentoPeso(entityClassificacao) && entityClassificacao.solicitarPrecoMedio">
                                            <sgt-decimal2 [ngModel]="entityClassificacao.pesoProjetadoValorUnitario" name="pesoProjetadoValorUnitario_{{entityClassificacaoIndex}}" id="pesoProjetadoValorUnitario_{{entityClassificacaoIndex}}"
                                                #pesoProjetadoValorUnitario="ngModel" [ngControl]="pesoProjetadoValorUnitario" #pesoProjetadoValorUnitarioDecimal
                                                (ngModelChange)="onChangePesoProjetadoValorUnitario(entityClassificacao, $event)" [required]="isPesoProjetadoValorUnitarioRequired(entityClassificacao)">
                                            </sgt-decimal2>
                                        </ng-template>
                                    </td>
                                    <td class="col-peso col-peso-pretendido text-right">
                                        {{entityClassificacao.pesoPretendido | decimalFormat: 1:0:0}}                                        
                                    </td>
                                    <td class="col-peso col-peso-projetado text-right">
                                        <ng-template [ngIf]="canEditLancamentoPeso(entityClassificacao)">
                                            <sgt-decimal2 [ngModel]="entityClassificacao.pesoProjetado" name="pesoProjetado_{{entityClassificacaoIndex}}" id="pesoProjetado_{{entityClassificacaoIndex}}"
                                                #pesoProjetado="ngModel" [ngControl]="pesoProjetado" [digits]="0"
                                                (ngModelChange)="onChangePesoProjetado(entityClassificacao, $event)">
                                            </sgt-decimal2>
                                        </ng-template>
                                        <ng-template [ngIf]="!canEditLancamentoPeso(entityClassificacao)">
                                            {{entityClassificacao.pesoProjetado | decimalFormat: 1:0:0}}
                                        </ng-template>

                                        <div class="progress-container" *ngIf="canEditLancamentoPeso(entityClassificacao)">
                                            <div class="progress-value">
                                                {{entityClassificacao.pesoProjetadoPerc | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entityClassificacao.pesoProjetadoPerc + '%'"
                                                    [attr.aria-valuenow]="entityClassificacao.pesoProjetadoPerc" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>                                         
                                    </td>
                                    <td class="col-peso col-peso-realizado text-right">
                                        {{entityClassificacao.pesoRealizado | decimalFormat: 1:0:0}}

                                        <div class="progress-container" *ngIf="canEditLancamentoPeso(entityClassificacao)">
                                            <div class="progress-value">
                                                {{entityClassificacao.pesoRealizadoPercProjetado | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entityClassificacao.pesoRealizadoPercProjetado + '%'"
                                                    [attr.aria-valuenow]="entityClassificacao.pesoRealizadoPercProjetado" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>                             
                                    </td>                                                                       
                                </ng-template>


                                <!-- Valor -->                           
                                <ng-template [ngIf]="configEmpresa?.controleValor">
                                    <td class="col-valor col-valor-pretendido text-right">
                                        {{entityClassificacao.valorPretendido | decimalFormat: 1:0:0}}                                    
                                    </td>
                                    <td class="col-valor col-valor-projetado text-right">
                                        <ng-template [ngIf]="canEditLancamentoValor(entityClassificacao)">
                                            <sgt-decimal2 [ngModel]="entityClassificacao.valorProjetado" name="valorProjetado_{{entityClassificacaoIndex}}" id="valorProjetado_{{entityClassificacaoIndex}}"
                                                #valorProjetado="ngModel" [ngControl]="valorProjetado" [digits]="0"
                                                (ngModelChange)="onChangeValorProjetado(entityClassificacao, $event)">
                                            </sgt-decimal2>                                        
                                        </ng-template>
                                        <ng-template [ngIf]="!canEditLancamentoValor(entityClassificacao)">
                                            {{entityClassificacao.valorProjetado | decimalFormat: 1:0:0}}
                                        </ng-template>
    
                                        <div class="progress-container">
                                            <div class="progress-value">
                                                {{entityClassificacao.valorProjetadoPerc | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entityClassificacao.valorProjetadoPerc + '%'"
                                                    [attr.aria-valuenow]="entityClassificacao.valorProjetadoPerc" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>                                     
                                    </td>
                                    <td class="col-valor col-valor-realizado text-right">
                                        {{entityClassificacao.valorRealizado | decimalFormat: 1:0:0}}
    
                                        <div class="progress-container">
                                            <div class="progress-value">
                                                {{entityClassificacao.valorRealizadoPercProjetado | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entityClassificacao.valorRealizadoPercProjetado + '%'"
                                                    [attr.aria-valuenow]="entityClassificacao.valorRealizadoPercProjetado" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>                                     
                                    </td>
                                </ng-template>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn btn-link btn-sm p-0" (click)="createLancamentoClassificacao()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Adicionar segmento
                    </button>
                </div>                            
            </ng-template>

            <ng-template [ngIf]="!entity?.classificacoes || entity?.classificacoes.length === 0">
                <div class="alert alert-info alert-cliente-analise-mercado-classificacao-empty" role="alert">
                    <h4 class="alert-cliente-analise-mercado-classificacao-empty-title">
                        <i class="fas fa-info" aria-hidden="true"></i>
                        Nenhum segmento adicionado
                    </h4>

                    <button type="button" class="btn btn-primary btn-sm mr-2" (click)="createLancamentoClassificacao()">
                        <i class="fas fa-plus" aria-hidden="true"></i> <span class="d-none d-sm-inline-block ml-1"> Começar a adicionar os segmentos</span>
                    </button>
                </div>
            </ng-template>
        </ng-template>
    </div>
</form>

<!-- Create Modal -->
<sgt-cliente-analise-mercado-lancamento-create-modal
    #classificacaoCreateModal
    (afterCreate)="onAfterCreateLancamentoClassificacao($event)">
</sgt-cliente-analise-mercado-lancamento-create-modal>
